<template>
    <dl class="description-list-wrapper">
        <DescriptionItem :label="$t('규칙 그룹명')">
            {{ detailData.name || '-' }}
        </DescriptionItem>
        
        <DescriptionItem :label="$t('연산자')">
            {{ getOperatorName || '-' }}
        </DescriptionItem>

        <DescriptionItem :label="$t('자식 그룹')">
            <div v-if="detailData.child_groups?.length > 0" class="d-flex" style="gap: 8px">
                <b-badge v-for="item in detailData.child_groups" :key="item.id">
                    {{ item.name}}
                </b-badge>
            </div>
            <template v-else> - </template>
        </DescriptionItem>

        <DescriptionItem :label="$t('조건')">
            <div v-if="detailData.conditions?.length > 0" class="d-flex" style="gap: 8px">
                    <b-badge v-for="item in detailData.conditions" :key="item.id">
                        {{ item.name}}
                    </b-badge>
            </div>
            <template v-else> - </template>
        </DescriptionItem>
        <DescriptionItem :label="$t('조건식')">
            <template v-if="getConditions.length > 0">
                <div v-for="(condition,idx) in getConditions" :key="`condition-${idx}`"
                     class="mr-1"
                >
                    <b-badge class="f-90"
                             variant="dark"
                    >
                        {{ condition }}
                    </b-badge>
                    <template v-if="idx !== getConditions.length - 1">
                        {{ detailData.operator }}
                    </template>
                </div>
            </template>
            <template v-else>
                -
            </template>
        </DescriptionItem>
        <DescriptionItem :label="$t('설명')">
            {{ detailData.description || '-' }}
        </DescriptionItem>

        <div class="row-wrapper">
            <DescriptionItem :label="$t('등록일시')">
                {{ get_date(detailData.created_at) || '-' }}
            </DescriptionItem>

            <DescriptionItem :label="$t('수정일시')">
                {{ get_date(detailData.updated_at) || '-' }}
            </DescriptionItem>
        </div>
    </dl>
</template>

<script>
import DescriptionItem from '@shared/components/common/DescriptionItem.vue';
import {operatorOptions} from '@shared/components/admin/pages/Management/CampaignConnectRule/RuleGroup/data';
import {getDate} from '@shared/components/admin/pages/Management/common-data';

export default {
    name: 'RuleGroupDetail',
    components: {
        DescriptionItem
    },
    props: {
        detailData: {
            type: Object,
            required: true,
            default: () => ({id: null}),
        },
    },
    computed: {
        getConditions(){
            const conditions = this.detailData.conditions?.map(item => {
                return `${item.key} ${item.operator} ${item.value}`;
            }) ?? [];
            const childConditions = this.detailData.child_groups?.reduce((acc, cur) => {
                if(cur.conditions == null){
                    return acc;
                }
                if(cur.conditions.length > 1){
                    const conditions = cur.conditions?.map(item => {
                        return `(${item.key} ${item.operator} ${item.value})`;
                    });
                    acc.push(conditions.join(` ${cur.operator} ` ));
                }
                else {
                    const conditions = cur.conditions?.map(item => {
                        return `${item.key} ${item.operator} ${item.value}`;
                    });
                    acc.push(conditions.join(cur.operator));
                }
                return acc;
            }, []) ?? [];
            return [...conditions, ...childConditions];
        },
        getOperatorName() {
            return operatorOptions.find(option => {
                return option.value === this.detailData.operator;
            })?.text ?? null;
        },
        get_date() {
            return (date) => {
                return getDate(date);
            };
        }
    }
};
</script>
<style scoped lang="scss">

</style>
